var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-enigmas"},[_c('enigma-toogle',{attrs:{"enigmasHeader":_vm.currentEnigmas,"group":_vm.group,"lastSuggestionsGroup":_vm.lastSuggestions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }